"use client";

import React from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "./ui/card";
import purchase from "../assets/images/purchase.png";
import { Button } from "./ui/button";
import { SecuredFooter } from "./ui/secured-footer";
import { TransactionDetails } from "./ui/transaction-details";

const WithdrawalComplete = ({ onDone, transactionData }) => {
  const navigate = useNavigate();

  const handleBackToWallet = () => {
    navigate("/trading/digitalWallet");
    if (onDone) onDone();
  };

  const handleViewHistory = () => {
    navigate("/trading/digitalWallet", {
      state: { openTransactionHistory: true },
    });
    if (onDone) onDone();
  };

  return (
    <Card className="w-full bg-white rounded-2xl !shadow-none pt-16 flex flex-col items-center text-center">
      <div className="flex flex-col items-center justify-center px-6">
        <img
          src={purchase}
          alt="Withdrawal Success"
          width={150}
          height={150}
          className="mb-6"
        />

        <h2 className="text-[32px] font-semibold text-[#33125F] mb-4">
          Ka-ching! Your withdrawal is complete
        </h2>
        <p className="text-[20px] font-normal text-[#423E51] mb-6">
          Your funds will reflect in your bank
        </p>

        {transactionData && (
          <div className="w-full max-w-md mb-6">
            <TransactionDetails
              amount={transactionData.amount}
              asset={transactionData.asset || "ZAR"}
              currency={transactionData.currency || "ZAR"}
              fees={transactionData.fees}
              transactionId={transactionData.transactionId}
              timestamp={transactionData.timestamp || new Date()}
              status={transactionData.status || "complete"}
            />
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-4 w-full sm:min-w-[302px] max-w-sm mx-auto mb-10">
          <Button
            onClick={handleBackToWallet}
            className="flex-1 px-6 py-4 rounded-full font-semibold transition-opacity h-[48px] text-sm sm:text-base bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] text-white hover:opacity-90"
          >
            Back to Wallet
          </Button>
          <Button
            onClick={handleViewHistory}
            variant="outline"
            className="flex-1 px-6 py-4 rounded-full font-semibold transition-opacity h-[48px] text-sm sm:text-base border-2 border-[#57249C] text-[#57249C] hover:bg-purple-50"
          >
            View Transaction History
          </Button>
        </div>
      </div>

      <div className="w-full">
        <SecuredFooter className="mt-6" />
      </div>
    </Card>
  );
};

export default WithdrawalComplete;
